export default __webpack_public_path__ + "static/media/802_06-18-2022_Jennifer+Jack_Wedding_tn.6e0c206e.jpg";